"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigationAccordion = _interopRequireDefault(require("../../navigation-accordion"));

var _productMenu = _interopRequireDefault(require("../../product-menu/product-menu"));

var _search = _interopRequireDefault(require("../../search/search"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Sidebar = /*#__PURE__*/function (_React$Component) {
  _inherits(Sidebar, _React$Component);

  var _super = _createSuper(Sidebar);

  function Sidebar() {
    _classCallCheck(this, Sidebar);

    return _super.apply(this, arguments);
  }

  _createClass(Sidebar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          constants = _this$props.constants,
          navigation = _this$props.navigation,
          location = _this$props.location,
          children = _this$props.children,
          parentPath = _this$props.parentPath,
          hideSearch = _this$props.hideSearch;
      var SITE = constants.SITE,
          BASEURL = constants.BASEURL;
      var title = navigation.title,
          tag = navigation.tag,
          path = navigation.path,
          navTabs = navigation.navTabs; // check if the site only has one page (one navTab with no sub pages)

      var isSinglePageSite = navigation && navTabs && navTabs.length < 2 && (!navTabs[0].pages || navTabs[0].pages.length === 0);
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-swiftype-index": "false",
        id: "dr-ui--page-layout-sidebar",
        className: "sticky-mm scroll-auto-mm scroll-styled viewport-almost-mm px12-mm",
        style: {
          top: '10px'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mb6 border-b border--darken10"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "mb6"
      }, /*#__PURE__*/_react.default.createElement(_productMenu.default, {
        productName: title || SITE,
        tag: tag || undefined,
        homePage: "".concat(BASEURL, "/").concat(path || '')
      })), !hideSearch &&
      /*#__PURE__*/

      /* set height to prevent content shift as Search component loads */
      _react.default.createElement("div", {
        className: "mb6 h36"
      }, /*#__PURE__*/_react.default.createElement(_search.default, _extends({}, this.props, {
        site: SITE
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('', {
          // if there is only one navTab (with no sub pages)
          // hide the NavigationAccordion on mobile
          'none block-mm': isSinglePageSite
        })
      }, /*#__PURE__*/_react.default.createElement(_navigationAccordion.default, {
        constants: constants,
        navigation: navTabs,
        location: location,
        parentPage: parentPath
      }, children)));
    }
  }]);

  return Sidebar;
}(_react.default.Component);

exports.default = Sidebar;
Sidebar.propTypes = {
  location: _propTypes.default.object.isRequired,
  navigation: _propTypes.default.shape({
    title: _propTypes.default.string,
    tag: _propTypes.default.string,
    navTabs: _propTypes.default.array,
    path: _propTypes.default.string,
    hierarchy: _propTypes.default.object
  }).isRequired,
  frontMatter: _propTypes.default.shape({
    navOrder: _propTypes.default.number,
    headings: _propTypes.default.array
  }).isRequired,
  parentPath: _propTypes.default.string,
  children: _propTypes.default.node,
  constants: _propTypes.default.shape({
    SITE: _propTypes.default.string.isRequired,
    BASEURL: _propTypes.default.string.isRequired
  }).isRequired,
  hideSearch: _propTypes.default.bool
};